import { StatsTimeframe } from '../types';
import { statsTimeframeToOffsetMap } from '../const';

export interface IGetStatsTimeBordersParams {
  timeframe: StatsTimeframe;
  timeframeShift?: number;
}

interface IGetStatsTimeBordersReturn {
  start: string; // RFC 3339 timestamp
  end: string; // RFC 3339 timestamp
  shift: number;
  startDate: Date;
  endDate: Date;
}

/**
 * Returns the start and end time for the given timeframe and shift.
 * The start time is calculated by subtracting the offset for the timeframe from the current time.
 * The end time is calculated by subtracting the shift from the current time.
 *
 * @param {StatsTimeframe} timeframe - The timeframe to calculate the start and end time for.
 * @param {number} [timeframeShift=0] - The shift to apply to the end time.
 * @returns {IGetStatsTimeBordersReturn} - An object containing the start and end time in ISO format, the shift, and the start and end date as Date objects.
 */

export const getStatsTimeBorders = ({
  timeframe,
  timeframeShift = 0,
}: IGetStatsTimeBordersParams): IGetStatsTimeBordersReturn => {
  const now = new Date();

  const offset = statsTimeframeToOffsetMap[timeframe];
  const shift = offset * timeframeShift;

  const startDate = new Date(now.getTime() - offset - shift);
  const endDate = new Date(now.getTime() - shift);

  const start = startDate.toISOString();
  const end = endDate.toISOString();

  return { end, start, shift, startDate, endDate };
};
